import { Box, ButtonGroup, IconButton, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

import { useGridApiRef } from "@mui/x-data-grid";
import WebshopCredentialsOrders from "./views/Orders";
import WebshopCredentialsOrderLogs from "./views/OrderLogs";
import TabView3 from "../../../../components/theme/TabView3/TabView3";
import { warehouseWebshopCredentialsDataConfig } from "./warehouseWebshopCredentialsDataConfig";
import WebshopCredentialsReturns from "./views/Returns";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import OverflowRow from "../../../../components/theme/OverflowRow";
import { Edit, ArrowRightAlt, Warning, Check, Close } from "@mui/icons-material";
import ShValidatedInputDropdown from "../../../../components/theme/dropdowns/ShValidatedInputDropdown";
import { useGetWebshopCredentialsSingleQuery, useGetWebshopCredentialsSelectQuery, useSyncWebshopChannelMutation, useGetWebshopCountQuery } from "../../../../newapi/webshop/webshopSlice";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import SpWebshopCredentialsDetails from "../../../../components/global/Sidepanels/SpWebshopCredentialsDetails/SpWebshopCredentialsDetails";
import ShLabel from "../../../../components/theme/label/ShLabel";
import { getWebshopLogo } from "../../../../utils/logomapper";
import Text from "../../../../components/theme/text/Text";
import { UnresolvedLogsProvider, useUnresolvedLogs } from "./contexts/UnresolvedLogsContext";
import WebshopCredentialsProducts from "./views/Products";
import AMRelationdata from "../../../../components/global/Modals/ActionModal/AMRelationdata";
import { showToastMessagePostRequest, showToastMessageRequestError } from "../../../../utils/toasts";
import { useTopbar } from "../../../../contexts/TopbarProvider";
import MLoader from "../../../../components/global/Modals/MLoader";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";

 // Render sync status indicators
 const RenderSyncStatus = (props) => {
  const {t, i18n} = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const syncStatuses = [
    { key: 'syncProducts', label: t('sync_products') },
    { key: 'syncStock', syncKey: 'lastStockSync', label: t('sync_stock') },
    { key: 'syncOrders', syncKey: 'lastOrderSync', label: t('sync_orders') },
    { key: 'syncCreateProducts', label: t('sync_create_products') }
  ];

  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 1.5, 
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      mt: 1
    }}>
      {/* Left side: Connection Status and Unresolved Logs */}
      <Box sx={{ 
        display: 'flex', 
        gap: 1.5, 
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        {/* Connection Status */}
        <ShLabel
          variant={props.webshopCredentialsData?.testConnection ? "green" : "red"}
          borderless
          size={32}
          fitted
          palette="normal"
          sx={{
            fontSize: '12px',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            px: 1.5,
            py: 0.5,
            borderRadius: 2,
            minWidth: 'fit-content'
          }}
        >
          {props.webshopCredentialsData?.testConnection ? (
            <Box
              sx={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                backgroundColor: 'currentColor',
                animation: 'pulse 2s infinite',
                '@keyframes pulse': {
                  '0%': {
                    opacity: 1,
                    transform: 'scale(1)',
                  },
                  '50%': {
                    opacity: 0.7,
                    transform: 'scale(1.2)',
                  },
                  '100%': {
                    opacity: 1,
                    transform: 'scale(1)',
                  },
                },
              }}
            />
          ) : (
            <Close sx={{ fontSize: '14px' }} />
          )}
          {props.webshopCredentialsData?.testConnection ? t('connection_active') : t('connection_failed')}
        </ShLabel>

        {/* Unresolved Logs Warning */}
        {props.hasUnresolvedLogs && (
          <ShLabel 
            variant="red" 
            borderless 
            size={32}
            fitted
            palette="normal"
            sx={{
              fontSize: '12px',
              fontWeight: 500,
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              px: 1.5,
              py: 0.5,
              borderRadius: 2,
              minWidth: 'fit-content'
            }}
          >
            <Warning fontSize="small" sx={{ fontSize: '14px' }} />
            {t('unresolved_logs')}
          </ShLabel>
        )}
      </Box>

      {/* Right side: Sync Status Indicators */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 0.5
      }}>
        <Text 
          sx={{ 
            fontSize: '13px', 
            fontWeight: 600,
            color: colors.txt.primary,
            mb: 0.5
          }}
        >
          {t('synchronizations')}
        </Text>
        <Box sx={{ 
          display: 'flex', 
          gap: 1, 
          alignItems: 'center',
          flexWrap: 'wrap',
          p: 1.5,
          borderRadius: 3,
          backgroundColor: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
          border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`,
          boxShadow: theme.palette.mode === "dark" ? 'none' : '0px 1px 3px rgba(0, 0, 0, 0.1)'
        }}>
          {syncStatuses.map(status => {
            const isEnabled = props.webshopCredentialsData?.[status.key];
            const syncDate = status.syncKey ? props.webshopCredentialsData?.[status.syncKey] : null;
            if (syncDate) {
              return (
              <SHQuickAction
                  disableScrollLock={true}
                  component={
                      <Box
                          sx={{
                              px:1.5,
                              display:"flex",
                              flexDirection:"column"
                          }}
                      >
                          <Text light>{t("last_sync_date")}</Text>
                          <Text>{new Date(syncDate).toLocaleDateString(i18n.language)} {new Date(syncDate).toLocaleTimeString(i18n.language, {hour: '2-digit', minute: '2-digit'})}</Text>
                      </Box>
                  }
                >
                    {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                        <Box
                            aria-owns={anchorEl ? 'simple-popover' : undefined}
                            aria-haspopup={false}
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            onTouchStart={onTouchStart}
                        >
                          <ShLabel
                            key={status.key}
                            variant={isEnabled ? "green" : "orange"}
                            borderless
                            size={32}
                            fitted
                            palette="normal"
                            sx={{
                              fontSize: '12px',
                              fontWeight: 500,
                              display: 'flex',
                              alignItems: 'center',
                              gap: 0.5,
                              px: 1.5,
                              py: 0.5,
                              borderRadius: 2,
                              minWidth: 'fit-content'
                            }}
                          >
                            {isEnabled ? (
                              <Check sx={{ fontSize: '14px' }} />
                            ) : (
                              <Close sx={{ fontSize: '14px' }} />
                            )}
                            {status.label}
                          </ShLabel>
                        </Box>
                    )}
                </SHQuickAction>
                  )
            } else {
              return (
                <ShLabel
                  key={status.key}
                  variant={isEnabled ? "green" : "orange"}
                  borderless
                  size={32}
                  fitted
                  palette="normal"
                  sx={{
                    fontSize: '12px',
                    fontWeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 2,
                    minWidth: 'fit-content'
                  }}
                >
                  {isEnabled ? (
                    <Check sx={{ fontSize: '14px' }} />
                  ) : (
                    <Close sx={{ fontSize: '14px' }} />
                  )}
                  {status.label}
                </ShLabel>
              );
            }
            
          })}
        </Box>
      </Box>
    </Box>
  );
};


const WebshopCredentialsDataContent = () => {
  const { t, ready,i18n } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isExtended, setIsExtended] = useState(false);
  const [spLoading, setSpLoading] = useState();
  
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [webshopCredentialsId, setWebshopCredentialsId] = useState(queryParams.get("webshop"));
  
  const { data: webshopCredentialsData, isLoading: webshopCredentialsIsLoading } = useGetWebshopCredentialsSingleQuery(webshopCredentialsId);
  const [config, setConfig] = useState(warehouseWebshopCredentialsDataConfig());
  const { data: webshopCredentials } = useGetWebshopCredentialsSelectQuery();
  const { hasUnresolvedLogs } = useUnresolvedLogs();

  const {showExtraTitle,clearExtraTitle } = useTopbar();
  
  useEffect(() => {
    if (webshopCredentialsData) {
      setConfig(warehouseWebshopCredentialsDataConfig({importOrderFailedCount: webshopCredentialsData.importOrderFailedCount}));
    }
  }, [webshopCredentialsData]);

  // Sync webshopCredentialsId state with URL params when location changes
  useEffect(() => {
    const urlWebshopCredentialsId = queryParams.get("webshop");
    if (urlWebshopCredentialsId !== webshopCredentialsId) {
      setWebshopCredentialsId(urlWebshopCredentialsId);
    }
  }, [location.search]);

  const getWebshopCredentialsDetails = () => {
    if (!spLoading) {
      setSpLoading(true);
    }
    setIsExtended(true);
  };

  const handleInput = (key, val) => {
    setWebshopCredentialsId(val);
    // Update URL parameters to maintain state
    const newSearchParams = new URLSearchParams(location.search);
    newSearchParams.set('webshop', val);
    navigate(`${location.pathname}?${newSearchParams.toString()}`, { replace: true });
  };

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const filterPopoverOpen = Boolean(filterAnchorEl);
  const filterPopoverId = filterPopoverOpen ? 'simple-popover' : undefined;
  const [isSyncing, setIsSyncing] = useState(false);


    const { data : totals, isLoading: totalIsLoading,error } = useGetWebshopCountQuery();
//   // Render sync status indicators
//   const renderSyncStatus = () => {
//     if (!webshopCredentialsData) return null;
    
//     const syncStatuses = [
//       { key: 'syncProducts', label: t('sync_products') },
//       { key: 'syncStock', label: t('sync_stock') },
//       { key: 'syncOrders', label: t('sync_orders') },
//       { key: 'syncCreateProducts', label: t('sync_create_products') }
//     ];

//     return (
//       <Box sx={{ 
//         display: 'flex', 
//         gap: 1.5, 
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         flexWrap: 'wrap',
//         mt: 1
//       }}>
//         {/* Left side: Connection Status and Unresolved Logs */}
//         <Box sx={{ 
//           display: 'flex', 
//           gap: 1.5, 
//           alignItems: 'center',
//           flexWrap: 'wrap'
//         }}>
//           {/* Connection Status */}
//           <ShLabel
//             variant={webshopCredentialsData.testConnection ? "green" : "red"}
//             borderless
//             size={32}
//             fitted
//             palette="normal"
//             sx={{
//               fontSize: '12px',
//               fontWeight: 500,
//               display: 'flex',
//               alignItems: 'center',
//               gap: 0.5,
//               px: 1.5,
//               py: 0.5,
//               borderRadius: 2,
//               minWidth: 'fit-content'
//             }}
//           >
//             {webshopCredentialsData.testConnection ? (
//               <Box
//                 sx={{
//                   width: '8px',
//                   height: '8px',
//                   borderRadius: '50%',
//                   backgroundColor: 'currentColor',
//                   animation: 'pulse 2s infinite',
//                   '@keyframes pulse': {
//                     '0%': {
//                       opacity: 1,
//                       transform: 'scale(1)',
//                     },
//                     '50%': {
//                       opacity: 0.7,
//                       transform: 'scale(1.2)',
//                     },
//                     '100%': {
//                       opacity: 1,
//                       transform: 'scale(1)',
//                     },
//                   },
//                 }}
//               />
//             ) : (
//               <Close sx={{ fontSize: '14px' }} />
//             )}
//             {webshopCredentialsData.testConnection ? t('connection_active') : t('connection_failed')}
//           </ShLabel>

//           {/* Unresolved Logs Warning */}
//           {hasUnresolvedLogs && (
//             <ShLabel 
//               variant="red" 
//               borderless 
//               size={32}
//               fitted
//               palette="normal"
//               sx={{
//                 fontSize: '12px',
//                 fontWeight: 500,
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: 0.5,
//                 px: 1.5,
//                 py: 0.5,
//                 borderRadius: 2,
//                 minWidth: 'fit-content'
//               }}
//             >
//               <Warning fontSize="small" sx={{ fontSize: '14px' }} />
//               {t('unresolved_logs')}
//             </ShLabel>
//           )}
//         </Box>

//         {/* Right side: Sync Status Indicators */}
//         <Box sx={{ 
//           display: 'flex', 
//           flexDirection: 'column',
//           alignItems: 'flex-end',
//           gap: 0.5
//         }}>
//           <Text 
//             sx={{ 
//               fontSize: '13px', 
//               fontWeight: 600,
//               color: colors.txt.primary,
//               mb: 0.5
//             }}
//           >
//             {t('synchronizations')}
//           </Text>
//           <Box sx={{ 
//             display: 'flex', 
//             gap: 1, 
//             alignItems: 'center',
//             flexWrap: 'wrap',
//             p: 1.5,
//             borderRadius: 3,
//             backgroundColor: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
//             border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[200]}`,
//             boxShadow: theme.palette.mode === "dark" ? 'none' : '0px 1px 3px rgba(0, 0, 0, 0.1)'
//           }}>
//             {syncStatuses.map(status => {
//               const isEnabled = webshopCredentialsData[status.key];
//               return (
//                 <ShLabel
//                   key={status.key}
//                   variant={isEnabled ? "green" : "orange"}
//                   borderless
//                   size={32}
//                   fitted
//                   palette="normal"
//                   sx={{
//                     fontSize: '12px',
//                     fontWeight: 500,
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: 0.5,
//                     px: 1.5,
//                     py: 0.5,
//                     borderRadius: 2,
//                     minWidth: 'fit-content'
//                   }}
//                 >
//                   {isEnabled ? (
//                     <Check sx={{ fontSize: '14px' }} />
//                   ) : (
//                     <Close sx={{ fontSize: '14px' }} />
//                   )}
//                   {status.label}
//                 </ShLabel>
//               );
//             })}
//           </Box>
//         </Box>
//       </Box>
//     );
// };
  
  const [syncWebshopChannel] = useSyncWebshopChannelMutation();
  useEffect(() => {
      showExtraTitle(
        <Box
          sx={{
            display:"flex",
            alignItems:'center',
            gap:1,
          }}
        >
          {t("webshopcredentials")} / 
          {totals &&
            <Box
              onClick={() => {
                window.open("/warehouse/settings/integrations/saleschannels?view=concept",'_blank')
              }}
              sx={{
                display:"flex",
                alignItems:'center',
                background: theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],
                height:32,
                borderRadius:4,
                px:2,
                pr:0.5,
                lineHeight:'32px',
                fontSize:14,
                fontWeight:"normal",
                color:colors.txt['primary'],
                gap:2,
                cursor:"pointer",
              }}
            >
              {t("concept")}
              <Box
                sx={{
                  fontWeight:"bold",
                  height:24,
                  lineHeight:'24px',
                  borderRadius:3,
                  background: theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[200],
                  color:colors.txt['primary'],
                  px:1.5,
                  cursor:"pointer",
                }}
              >
                {totals.concept}
              </Box>
            </Box>
          }
        </Box>
      )

      return () => {
          clearExtraTitle();
      };
  }, [showExtraTitle,clearExtraTitle,t,i18n.language,totals])

  return (
    <Box sx={{ background: "", width: 1, paddingTop: 3 }}>
      {ready ? (
        <>
          <OverflowRow>
            <Box
              sx={{
                flex: 1,
                position: "relative",
                display: "flex",
                justifyContent: "space-between",
                borderRadius: 4,
                gap: 1,
              }}
            >
              <Box 
                sx={{ 
                  display: "flex", 
                  justifyContent: "start", 
                  width: 1, 
                  flexDirection: "column", 
                  paddingTop:2,
                }}
              >
                <Box 
                  sx={{ 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "space-between", 
                    width: "100%" 
                  }}
                >
                  <Box 
                    sx={{ 
                      display: "flex", 
                      alignItems: "center" 
                    }}
                  >
                    {webshopCredentialsData && (
                      <Box sx={{ paddingRight: 2 }}>
                        {getWebshopLogo(webshopCredentialsData.webshop_type,{theme,colors})}
                      </Box>
                    )}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2, paddingTop: 2 }}>
                      <ShValidatedInputDropdown
                        variant="darker"
                        displayName={"combined"}
                        changeField={"id"}
                        valueKey={"id"}
                        closeOnSelection
                        searchOptions={{
                          enabled: true,
                          placeholder: t("search_webshop_credentials_placeholder")
                        }}
                        styles={{
                          minWidth: 300,
                          "& .MuiInputBase-root": {
                            fontSize: "2.5rem",
                            fontWeight: 700,
                            color: "inherit",
                            "& .MuiSelect-select": {
                              fontSize: "2.5rem",
                              fontWeight: 700,
                              padding: "12px 32px 12px 16px"
                            }
                          }
                        }}
                        disallowDeselection
                        name="webshopCredentialsId"
                        selected={webshopCredentialsId ? parseInt(webshopCredentialsId) : -1}
                        options={webshopCredentials ? webshopCredentials : []}
                        noSelection={t("choose_other_webshop_credentials")}
                        onChange={handleInput}
                      />
                    </Box>
                  </Box>
                  <Box sx={{ paddingTop: 4,display:"flex",gap:1.5, }}>
                    <Shbutton
                        color={theme.palette.mode === "dark" ? "blue" : "primary"}
                        onClick={getWebshopCredentialsDetails}
                        endIcon={<Edit />}
                        variant="contained"
                        sx={{
                          px:2,
                        }}
                      >
                      {t("edit_credentials")}
                    </Shbutton>
                    <Shbutton
                      onClick={(event) => {setFilterAnchorEl(event.currentTarget);}}
                      className={"group-btn"}
                      // onClick={props.action}
                      color={"primaryGrey"}
                      variant="contained"
                    >
                        {t('actions')}
                    </Shbutton>
                    <AMRelationdata
                      id={filterPopoverId}
                      open={filterPopoverOpen}
                      onClose={() => {setFilterAnchorEl(null)}}
                      anchorEl={filterAnchorEl}
                      syncProducts={async () => {
                        setIsSyncing(true);
                        await syncWebshopChannel({
                          id:webshopCredentialsId,
                          type:'products'
                        })
                        .unwrap()
                        .then(res => {
                          showToastMessagePostRequest(t,res);
                        })
                        .catch(err => {
                          showToastMessageRequestError(t("sync_failed"), t, err);
                        })
                        .finally(() => {
                          setIsSyncing(false);
                        })
                      }}
                      syncStock={async () => {
                        setIsSyncing(true);
                        await syncWebshopChannel({
                          id:webshopCredentialsId,
                          type:'stock'
                        })
                        .unwrap()
                        .then(res => {
                          showToastMessagePostRequest(t,res);
                        })
                        .catch(err => {
                          showToastMessageRequestError(t("sync_failed"), t, err);
                        })
                        .finally(() => {
                          setIsSyncing(false);
                        })
                      }}
                    />
                  </Box>
                </Box>

                <Box sx={{ paddingTop: 2 }}>
                  {webshopCredentialsData &&
                    <RenderSyncStatus 
                      webshopCredentialsData={webshopCredentialsData}
                      hasUnresolvedLogs={hasUnresolvedLogs}
                    />
                  }
                  {/* {renderSyncStatus()} */}
                </Box>
              </Box>
            </Box>
          </OverflowRow>

          <TabView3
            tabConfig={config}
            sx={{
              background: "green",
              minHeight: "calc(100% - 190px)",
              background: `${
                theme.palette.mode === "dark"
                  ? colors.grey[200]
                  : colors.grey[0]
              }`,
              position: "relative",
              zIndex: 2,
              display: "flex",
              flexDirection: "column",

              "&:before": {
                content: "''",
                display: "block",
                width: "32px",
                height: "32px",
                position: "absolute",
                left: 0,
                zIndex: 1,
                backgroundColor: `${
                  theme.palette.mode === "dark"
                    ? colors.grey[200]
                    : colors.grey[0]
                }`,
                top: "40px",
                height: "48px",
                width: "24px",
                borderTopLeftRadius: "24px",
                boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                transition: "250ms",
              },

              "&:after": {
                content: "''",
                display: "block",
                width: "32px",
                height: "32px",
                position: "absolute",
                top: 0,
                zIndex: 1,
                backgroundColor: `${
                  theme.palette.mode === "dark"
                    ? colors.grey[200]
                    : colors.grey[0]
                }`,
                top: "40px",
                right: 0,
                height: "48px",
                width: "24px",
                borderTopLeftRadius: "24px",
                boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                transform: "scaleX(-1)",
                transition: "250ms",
              },

              "@media screen and (max-width: 47.9375em)": {
                "&:after, &:before": {
                  top: "-0px",
                },
              },
            }}
          >
            <>
              <WebshopCredentialsOrders webshopCredentialsId={webshopCredentialsId} config={config.orders} />
              <WebshopCredentialsOrderLogs webshopCredentialsId={webshopCredentialsId} webshopType={webshopCredentialsData?.webshop_type} config={config.orderlogs} />
              <WebshopCredentialsReturns webshopCredentialsId={webshopCredentialsId} config={config.returns} />
              <WebshopCredentialsProducts webshopCredentialsId={webshopCredentialsId} config={config.products} />
            </>
          </TabView3>
          
          {spLoading &&
            <SpWebshopCredentialsDetails
              isExtended={isExtended}
              setIsExtended={setIsExtended}
              webshopCredentialsId={webshopCredentialsId}
            />
          }

          <MLoader
            open={isSyncing}
            message={t('synchronizing_it_can_take_a_while')}
          />
        </>
      ) : null}
    </Box>
  );
};

const WebshopCredentialsData = () => {
  return (
    <UnresolvedLogsProvider>
      <WebshopCredentialsDataContent />
    </UnresolvedLogsProvider>
  );
};

export default WebshopCredentialsData; 